import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "antd";
import { Form } from "react-final-form";

import {
  ApplicationsActions,
  isReqAdditionalDocsLoading,
  selectCurrentApplicationId
} from "@redux";
import { i18, required, trb } from "@utilities";
import { ContentLoader, FormField, FormFieldType } from "@components";

export const AdditionalDocsModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const appId = useSelector(selectCurrentApplicationId);
  const isLoading = useSelector(isReqAdditionalDocsLoading);

  const handleRequestDocsSubmit = async values => {
    await dispatch(
      ApplicationsActions.requestAdditionalDocuments(
        values,
        appId,
        i18.NotificationTitles.SuccessOperation
      )
    );
    onClose();
  };

  return (
    <Form
      onSubmit={handleRequestDocsSubmit}
      render={({ handleSubmit }) => {
        return (
          <Modal
            visible
            onOk={handleSubmit}
            onCancel={onClose}
            cancelButtonProps={{ loading: isLoading, disabled: isLoading }}
            okButtonProps={{ loading: isLoading, disabled: isLoading }}
            okText={trb(i18.Buttons.Ok)}
            cancelText={trb(i18.Buttons.Cancel)}
          >
            <form className="mb-3" id="requestAdditionalDocuments" onSubmit={handleSubmit}>
              {isLoading ? (
                <ContentLoader />
              ) : (
                <FormField
                  name="comment"
                  component={FormFieldType.textEditor}
                  title={trb(i18.ApplicationsLabels.Comment)}
                  validate={required}
                  size="large"
                />
              )}
            </form>
          </Modal>
        );
      }}
    />
  );
};
